import Typography from '@mui/material/Typography';
import { TreeItem, useTreeItemState } from '@mui/x-tree-view/TreeItem';
import * as React from 'react';
import type { TreeItemProps, TreeItemContentProps } from '@mui/x-tree-view/TreeItem';

const CustomContent = React.forwardRef(function CustomContent(
  props: TreeItemContentProps,
  ref
) {
  const {
    classes,
    className,
    label,
    itemId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
  } = props;

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItemState(itemId);

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing
  const icon = iconProp || expansionIcon || displayIcon;

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    preventSelection(event);
  };

  const handleExpansionClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    handleExpansion(event);
  };

  const handleSelectionClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    handleSelection(event);
  };

  const classNames = [
    className,
    classes.root,
    expanded && classes.expanded,
    selected && classes.selected,
    focused && classes.focused,
    disabled && classes.disabled,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={classNames}
      onMouseDown={handleMouseDown}
      ref={ref as React.Ref<HTMLDivElement>}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={handleExpansionClick} className={classes.iconContainer}>
        {icon}
      </div>
      <Typography
        onClick={handleSelectionClick}
        component='div'
        className={classes.label}>
        {label}
      </Typography>
    </div>
  );
});

export default function CustomTreeItem(props: TreeItemProps): JSX.Element {
  return <TreeItem ContentComponent={CustomContent} {...props} />;
}
